<template>
  <div class="container workshops">
    <div class="row mb-45">
      <div class="col-lg-8 col-12">
        <h1>Wellbeing Workshops</h1>
      </div>
      <div class="col-12 col-lg-4 text-right mt-1">
        <router-link to="/workshops/create">
          <button class="btn btn-primary profile-button btn-wide create-button">
            <span>Host Wellbeing Workshop</span>
          </button>
        </router-link>
      </div>
    </div>

    <div class="row" v-if="loading && !workshops.length">
      <Loader style="width: 100%;" />
    </div>

    <div class="row" v-else>
      <div class="col-12 d-lg-none">
        <button class="modal-filters btn-secondary large-filters-btn" type="button" @click="showFilters()">
          <font-awesome-icon :icon="['fas', 'sliders-v']" class="icon alt" />
          <span>Filters</span>
        </button>
      </div>
      <div class="col-12 col-lg-8">
        <div class="dashboard-card workshops-list" v-if="workshops.length === 0">
          No workshops were found.
          <div class="d-lg-none">
            <button class="btn modal-filters btn-primary mt-4" type="button" @click="showFilters()">
              Change Filters
            </button>
          </div>
        </div>

        <div class="dashboard-card workshops-list" v-else>
          <div class="session" v-for="(workshop, index) in workshops" :key="workshop.id">
            <div class="row">
              <div class="col-12 col-lg-8">
                <h3>{{ workshop.topic }}</h3>
                <h5 v-if="workshop.host">{{ workshop.host.name }}</h5>
                <p>{{ workshop.start_time | date }}</p>
                <span class="spot-number d-lg-none">
                  <span v-if="workshop.num_spots_left === 1">
                    {{ workshop.num_spots_left }} Spot Left!
                  </span>
                  <span v-else>
                    {{ workshop.num_spots_left }} Spots Left!
                  </span>
                </span>
                <span class="spot-number d-lg-none">
                  <span v-if="workshop.status === 'requested'">
                    Requested
                  </span>
                  <span v-else-if="workshop.status === 'approved'">
                    Approved
                  </span>
                  <span v-else-if="workshop.status === 'started'">
                    In Progress
                  </span>
                  <span v-else-if="workshop.status === 'ended'">
                    Ended
                  </span>
                </span>
              </div>
              <div class="col-12 d-none d-lg-block col-lg-4 text-right">
                <ul class="pills">
                  <li>
                    <span v-if="workshop.num_spots_left === 1">
                      {{ workshop.num_spots_left }} Spot Left!
                    </span>
                    <span v-else>
                      {{ workshop.num_spots_left }} Spots Left!
                    </span>
                  </li>
                  <status-list-item :status="workshop.status"/>
                </ul>
              </div>
            </div>
            <div class="row" v-if="workshop.struggle_areas.length">
              <ul class="pills">
                <li v-for="area of workshop.struggle_areas" :key="area.id">
                  {{ area.name }}
                </li>
              </ul>
            </div>

            <div class="accordion" role="tablist">
              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <button class="btn btn-secondary block w-100" v-b-toggle="'collapse-description-' + index">
                    View Description
                  </button>
                </b-card-header>
                <b-collapse :id="'collapse-description-' + index" accordion="my-accordion" role="tabpanel">
                  <b-card-body class="description">
                    <b-card-text>{{ workshop.description }}</b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card no-body class="mb-1" v-if="workshop && workshop.attendees && workshop.attendees.length">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <button class="btn btn-secondary block w-100" v-b-toggle="'collapse-attendees-'+ index">
                    View Attendees
                </button>
                </b-card-header>
                <b-collapse :id="'collapse-attendees-'+ index" accordion="my-accordion" role="tabpanel">
                    <b-card-body class="description">
                        <b-card-text>
                            <table class="responsive-table">
                                <thead>
                                    <tr>
                                        <th>First Name</th>
                                        <th>Last Name</th>
                                        <th/>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="attendee in workshop.attendees" :key="attendee.userId">
                                        <td>
                                            {{ attendee.firstName }}
                                        </td>
                                        <td>
                                            {{ attendee.lastName }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </b-card-text>
                    </b-card-body>
                </b-collapse>
              </b-card>
              <b-card no-body class="mb-1" v-if="notStarted(workshop)">
                <b-card-header header-tag="header" class="p-1" role="tab" >
                    <button class="btn btn-secondary block w-100" v-b-toggle="'collapse-cancel-' + index">
                        Cancel Workshop
                    </button>
                </b-card-header>
                <b-collapse :id="'collapse-cancel-' + index" accordion="my-accordion" role="tabpanel">
                    <b-card-body class="description">
                        <b-card-text>
                            <p>Are you sure you want to cancel this workshop?</p>
                            <button class="btn cancel-button" @click="doCancel(workshop.id)">
                              Cancel Workshop
                            </button>
                        </b-card-text>
                    </b-card-body>
                </b-collapse>
              </b-card>
            </div>
            
          </div>
          <div>
            
            <Loader v-if="loading" style="width: 100%" />
            <button class='btn' v-else-if="pageToken" @click="loadWorkshops">
              Load Next
            </button>
            <div v-else>
              <p>
                <font-awesome-icon :icon="['fas', 'check-circle']" class="icon alt" />
                All Results Loaded
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="d-none d-lg-block col-lg-4">
        <div class="dashboard-card filter-sidebar">
          <workshops-list-filter :value="filters" @input="resetFilters" />
        </div>
      </div>
    </div>

    <b-modal ref="filtersModal" id="filters-modal">

      <workshops-list-filter v-model="modalFilters" />

      <template slot="modal-footer">
        <button class="btn" type="button" @click="hideFilters()">
          Cancel
        </button>
        <button class="btn btn--primary" type="button" @click="doModalFilters()">
          Filter
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import ConfirmModal from '@/components/modals/ConfirmModal.vue';
import Loader from '@/components/Loader';
import WorkshopClient from '@/api/WorkshopClient';
import moment from 'moment';
import WorkshopsListFilter from './components/WorkshopsListFilter.vue'
import WorkshopView from './WorkshopView'
import StatusListItem from './components/StatusListItem.vue'

export default {
  name: 'WorkshopsList',
  components: {
    Loader,
    WorkshopsListFilter,
    StatusListItem,
    ConfirmModal,
  },
  data() {
    return {
      workshopClient: new WorkshopClient(this.$http),
      selectedWorkshop: null,
      workshops: [],
      pageToken: null,
      loading: false,

      filters: {
        specialty: '',
        start_time_after: moment().toISOString(),
        start_time_before: '',
        specialty_ids: [],
      },
      modalFilters: {
        specialty: '',
        start_time_after: '',
        start_time_before: '',
        specialty_ids: [],
      },
    };
  },
  async mounted() {
    const { id, from } = this.$route.params;

    if (from && from === 'new-workshop') {
      this.$store.commit('setGlobalAlert', {
        msg: 'Workshop has been requested!',
      });
    }

    this.loadWorkshops(id);
  },
  methods: {
    notStarted(workshop) {
      const now = moment();
      const start = moment(workshop.start_time);
      return start.diff(now, 'minutes') > 15;
    },
    showFilters() {
      this.modalFilters = { ...this.filters };
      this.$refs.filtersModal.show();
    },
    doModalFilters() {
      this.filters = { ...this.modalFilters };
      this.hideFilters();
      this.pageToken = null;

      return this.loadWorkshops();
    },
    hideFilters() {
      this.$refs.filtersModal.hide();
    },
    resetFilters(filters) {
      this.filters = filters;
      this.pageToken = null;

      return this.loadWorkshops();
    },

    async doCancel(workshopId) {
      try {
        await this.workshopClient.cancel(workshopId)
        this.$store.commit('setGlobalAlert', {
          msg: 'You have successfully canceled your workshop.',
        });
        this.loadWorkshops();
      } catch (ex) {
        this.$store.commit('setGlobalAlert', {
          msg: 'Failed to cancel your workshop. Please try again!', error: true,
        });
      }
    },

    async loadWorkshops(id) {

      try {
        this.loading = true;

        const filters = {
          excludedStatuses: [
            'canceled',
            'rejected'
          ]
        }

        if (this.filters.specialty_ids) {
          filters.related_topics = this.filters.specialty_ids.map(s => s.id);
        }

        if (this.filters.start_time_after) {
          filters.start_time_after = moment(this.filters.start_time_after).startOf('day').toISOString();
        }

        if (this.filters.start_time_before) {
          filters.start_time_before = moment(this.filters.start_time_before).endOf('day').toISOString()
        }

        if (this.pageToken == null)
          this.workshops.length = 0;

        const response = await this.workshopClient.listForCounselor(
          this.pageToken,
          this.$store.getters.currentUser.counselor_profile.id,
          filters.start_time_after,
          filters.start_time_before,
          filters.related_topics,
          filters.excludedStatuses);

        this.pageToken = response.nextPageToken;

        const mapped = (response.workshops || []).map(this.toWorkshopView)
        for (const workshop of mapped) {
          this.workshops.push(workshop);
        }

        if (id) {
          let workshop = this.workshops.find(x => x.id == id)
          if (workshop)
            this.viewWorkshop(workshop)
        }
      } catch (ex) {
        console.error(ex)
      } finally {
        this.loading = false;
      }
    },
    toWorkshopView(val, index, arr) {
      return new WorkshopView(val)
    },

    specialtyChanged(newTags) {
      this.filters.specialty_ids = newTags;
      this.loadWorkshops();
    },
    modalSpecialtyChanged(newTags) {
      this.modalFilters.specialty_ids = newTags;
      this.loadWorkshops();
    },
  },
};
</script>

<style lang="scss" scoped>
.workshops {
  .workshops-list {
    .upper {
      margin-bottom: 30px;
    }

    .nav-buttons {
      position: absolute;
      right: 42px;
      top: 28px;

      @media (max-width: $xs-max) {
        position: static;
        margin-top: 20px;
      }

      button {
        background: none;
        border: none;
        color: white;
        font-size: 30px;
        width: 35px;

        @media (max-width: $md-max) {
          width: 50px;
        }
      }
    }
    
    .session {
      @include border-radius($border-radius);

      border: solid 1px rgba(white, 0.5);
      padding: 30px;
      margin-bottom: 10px;
      background-color: $off-blue;

      p {
        color: rgba(white, 0.75);
        font-size: 18px;
        margin-bottom: 20px;
      }

      .spot-number {
        color: $green;
        margin-bottom: 30px;
        display: block;
        font-weight: bold;
      }
    }

    .description {
        background-color: $textbox-bg-color;
        min-height: 100px;
        overflow: auto;
        word-wrap: break-word;

    }
    .accordion {
        .card {
            background-color: $off-blue;
            border: 0px;
        }
        .btn {
            background-color: $dark-green;
            border-color: $border-color;
        }
        .cancel-button {
            background-color: $red;
            color: $light-gray;
            border-color: $light-gray;
        }
     
        .responsive-table {
            width:100%;
            th{
                border-bottom: 1px solid rgba(255, 255, 255, 0.25);
            }
            tbody {
                tr {
                    td {
                        padding: 0.75rem;
                        color: rgba(white, 0.87);
                        border-top: 1px solid rgba(255, 255, 255, 0.25);

                    a {
                        color: darken($highlight-color, 5%);
                    }
                }
            }
        }
        @media (max-width: $sm-max) {
      display: block;
      border: none;

      thead,
      tbody,
      th,
      td,
      tr {
        display: block;
      }

      tbody {
        tr {
          background: $dark-blue;
          border: solid 1px $border-color;

          td {
            padding: 0.75rem;
            text-align: right;
            border-bottom: none;
            border-top: 1px solid rgba(255, 255, 255, 0.25);

            &:first-of-type {
              border-top: none;
            }

            &:last-of-type {
              border-bottom: none;
            }
          }
        }
      }

      thead tr {
        position: absolute;
        top: -9999px;
        left: -9999px;
      }

      tr {
        @include border-radius($border-radius);

        margin: 0 0 1rem 0;
        background: white;
      }

      td {
        position: relative;
        padding-left: 50%;
        border: none;
        border-bottom: $secondary-border;

        label {
          position: absolute;
          top: 12.5px;
          left: 15px;
          width: 45%;
          padding-right: 10px;
          font-weight: bold;
          white-space: nowrap;
          text-align: left;
        }
      }

      .btn-ghost {
        border-color: $primary-color;
        background: $primary-color;
        color: $btn-color;
        height: 45px;

        &:hover,
        &:focus {
          border-color: darken($primary-color, 5%);
          background-color: darken($primary-color, 5%);
          color: $btn-color;
        }
      }
    }
  }
}

  }

}



</style>
